var RemovedOutcomesModifier = /** @class */ (function () {
    function RemovedOutcomesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    RemovedOutcomesModifier.prototype.modify = function (content) {
        if (content.outcomes === undefined) {
            return;
        }
        var outcomes = content.outcomes.remove;
        if (outcomes !== undefined) {
            for (var i = 0; i < outcomes.length; i++) {
                outcomes[i] = this._modelKeyRepository.removeOutcome(outcomes[i]);
            }
        }
    };
    return RemovedOutcomesModifier;
}());
export default RemovedOutcomesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/RemovedOutcomesModifier.js